import React from 'react'
import './index.scss'

const MixBlock3 = (props) => {
  const { id, pid, config, rowType, clickTo } = props
  let bgColor = config.bgColor
    ? config.bgColor
    : rowType === 'bgBlock'
    ? 'rgba(0,0,0,0.8)'
    : '#fff'
  return (
    <div
      style={
        rowType !== 'bgBlock'
          ? { background: bgColor }
          : {
              backgroundImage: `linear-gradient(${bgColor},${bgColor}),url(${config.imgSrc})`,
            }
      }
      className={`${rowType || 'imageBlock'} lego_rowsBlock3`}
      onClick={() => clickTo('mixedBlock', config.deepLink, config.link, id)}
    >
      {rowType !== 'bgBlock' && (
        <div className="block3ImgContent">
          <img src={config.imgSrc}></img>
        </div>
      )}
      <div className={`block3TextContent ${config.textModel}`}>
        <div className="block3text">
          <p className="block3Title1">{config.title1}</p>
          <p className="block3Title2">{config.title2}</p>
        </div>
        <div className="enterNow">
          <span>{config.enterText || '马上进入'}</span>
          <span className="rightArraw">{'>'}</span>
        </div>
      </div>
    </div>
  )
}

export default MixBlock3
